// extracted by mini-css-extract-plugin
export var active = "shopItemImageCarousel-module--active--sV6+x";
export var arrow = "shopItemImageCarousel-module--arrow--zJPzB";
export var container = "shopItemImageCarousel-module--container--lJyao";
export var left = "shopItemImageCarousel-module--left--12fpq";
export var right = "shopItemImageCarousel-module--right--iAESy";
export var selectedImageContainer = "shopItemImageCarousel-module--selected-image-container--7g1NZ";
export var selectedImageWrapper = "shopItemImageCarousel-module--selected-image-wrapper--A6tws";
export var thumbnailImage = "shopItemImageCarousel-module--thumbnail-image--hbo1O";
export var thumbnailImagesContainer = "shopItemImageCarousel-module--thumbnail-images-container--rQ0n1";